import type { BlogListParams } from '../types/blog.types'

export const blogsKeys = {
  all: ['blogs'] as const,
  lists: () => [...blogsKeys.all, 'list'] as const,
  list: (params: BlogListParams) => [...blogsKeys.lists(), params] as const,
  details: () => [...blogsKeys.all, 'detail'] as const,
  detail: (slug: string) => [...blogsKeys.details(), slug] as const,
}
